import { render, staticRenderFns } from "./TieBreakerRules.vue?vue&type=template&id=c3fb600e&scoped=true&"
import script from "./TieBreakerRules.vue?vue&type=script&lang=js&"
export * from "./TieBreakerRules.vue?vue&type=script&lang=js&"
import style0 from "./TieBreakerRules.vue?vue&type=style&index=0&id=c3fb600e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fb600e",
  null
  
)

export default component.exports